import { render, staticRenderFns } from "./select-standard.vue?vue&type=template&id=704ec33f&scoped=true&"
import script from "./select-standard.vue?vue&type=script&lang=js&"
export * from "./select-standard.vue?vue&type=script&lang=js&"
import style0 from "./select-standard.vue?vue&type=style&index=0&id=704ec33f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ec33f",
  null
  
)

export default component.exports